import GAProfile from 'atoms/GAProfile'

const GAProfiles = props => (
  <div className='ga-profiles center column'>
    <div className='ga-profiles-title'>
      Please select Google Analytics profile
    </div>
    { props.gaProfiles.map(p => <GAProfile {...p} onClick={props.onClick} />) }
  </div>
)

export default GAProfiles
